var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 8.2002H11.2C9.53328 8.2002 8.19995 9.53352 8.19995 11.2002V20.8002C8.19995 22.4669 9.53328 23.8002 11.2 23.8002H20.8C22.4666 23.8002 23.8 22.4669 23.8 20.8002V11.2002C23.8 9.53352 22.4666 8.2002 20.8 8.2002ZM21.6666 10.0002H22V12.6669H19.3333V10.0002H21.6666ZM13.8 14.4002C14.2666 13.7335 15.1333 13.2669 16 13.2669C16.8666 13.2669 17.7333 13.7335 18.2 14.4002C18.5333 14.8669 18.7333 15.4002 18.7333 16.0002C18.7333 17.5335 17.4666 18.7335 16 18.7335C14.5333 18.7335 13.2666 17.5335 13.2666 16.0002C13.2666 15.4002 13.4666 14.8669 13.8 14.4002ZM22.2666 20.8002C22.2666 21.6002 21.6 22.2669 20.8 22.2669H11.2C10.4 22.2669 9.73329 21.6002 9.73329 20.8002V14.4002H12.0666C11.8666 14.8669 11.7333 15.4669 11.7333 16.0002C11.7333 18.3335 13.6666 20.2669 16 20.2669C18.3333 20.2669 20.2666 18.3335 20.2666 16.0002C20.2666 15.4669 20.1333 14.8669 19.9333 14.4002H22.2666L22.2666 20.8002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagramIcon.eb0cc584e09dd58109c93a86625e8a92.svg";
export { ForwardRef as ReactComponent };